import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex items-center gap-4 mb-4 -mx-2" }
const _hoisted_2 = { class: "-mx-4" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Initial ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Processing ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Done ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Error")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Done")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Initial ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Processing ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Canceled ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Error")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Detail")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" Download ")
const _hoisted_14 = { class: "flex justify-end mt-5" }

import { reactive, ref } from 'vue'
import { formatTime } from '@/utils/dateTime'
import { getFullUrlLattePrint } from '@/utils/image'
import { Search } from '@element-plus/icons'
import axios from '@/services/axios'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading = ref(false)
const records = ref([])
const totalPages = ref(1)
const filters = reactive({
  page: 1,
  limit: 15,
  search: '',
  importStatus: '',
  syncStatus: '',
})
const filterDates = ref<string[]>([])
const statusList = [
  { label: 'Initial', value: 'INIT' },
  { label: 'Processing', value: 'PROCESSING' },
  { label: 'Done', value: 'DONE' },
  { label: 'Error', value: 'ERROR' },
]

function onDownload(path: string) {
  const url = getFullUrlLattePrint(path) || ''
  const element = document.createElement('a')
  element.href = url
  element.setAttribute('download', '')
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}
async function getData() {
  try {
    loading.value = true
    const params: any = {
      ...filters,
      startDate: filterDates.value?.[0] || '',
      endDate: filterDates.value?.[1] || '',
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      importType: 'IMPORT_CATALOG_CODE_AND_DESIGN',
    }
    if (!params.search) delete params.search
    if (!params.startDate || !params.endDate) {
      delete params.startDate
      delete params.endDate
      delete params.timeZone
    }
    if (!params.importStatus) delete params.importStatus
    if (!params.syncStatus) delete params.syncStatus
    const { data } = await axios.get('import/history', {
      params,
    })
    records.value = data?.data || []
    totalPages.value = Math.ceil(data?.pagination?.total / params.limit)
  } catch (error) {
    console.log('🚀 ~ getData ~ error:', error)
  } finally {
    loading.value = false
  }
}
getData()

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_input, {
        modelValue: _unref(filters).search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filters).search) = $event)),
        size: "large",
        placeholder: "Search by file name",
        clearable: "",
        onChange: getData
      }, {
        append: _withCtx(() => [
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_unref(Search))
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        modelValue: filterDates.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterDates).value = $event)),
        type: "daterange",
        "unlink-panels": "",
        "range-separator": "To",
        "start-placeholder": "Start date",
        "end-placeholder": "End date",
        size: "large",
        "value-format": "YYYY-MM-DD",
        onChange: getData,
        class: "flex-shrink-0"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: _unref(filters).importStatus,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filters).importStatus) = $event)),
        placeholder: "Import Status",
        clearable: "",
        onChange: getData,
        class: "flex-shrink-0"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, (item) => {
            return _createVNode(_component_el_option, {
              key: item.value,
              placeholder: "Status",
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: _unref(filters).syncStatus,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filters).syncStatus) = $event)),
        placeholder: "Sync Status",
        clearable: "",
        onChange: getData,
        class: "flex-shrink-0"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(statusList, (item) => {
            return _createVNode(_component_el_option, {
              key: item.value,
              placeholder: "Status",
              label: item.label,
              value: item.value
            }, null, 8, ["label", "value"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_el_table, {
        "element-loading-text": "Loading history...",
        data: records.value,
        "row-key": "_id",
        stripe: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "Created",
            prop: "createdAt",
            width: 200
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_unref(formatTime)(row.createdAt)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "File name",
            prop: "fileName"
          }),
          _createVNode(_component_el_table_column, {
            label: "Records",
            prop: "numberRecords",
            align: "right",
            width: 80
          }),
          _createVNode(_component_el_table_column, {
            label: "Import status",
            prop: "importStatus",
            width: 150,
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              (row.importStatus === 'INIT')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "info"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }))
                : (row.importStatus === 'PROCESSING')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }))
                  : (row.importStatus === 'DONE')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 2,
                        type: "success"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_el_tag, {
                        key: 3,
                        type: "danger"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Sync status",
            prop: "syncStatus",
            width: 150,
            align: "center"
          }, {
            default: _withCtx(({ row }) => [
              (row.syncStatus === 'DONE')
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    type: "success"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : (row.syncStatus === 'INIT')
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 1,
                      type: "info"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }))
                  : (row.syncStatus === 'PROCESSING')
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 2,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      }))
                    : (row.syncStatus === 'CANCEL')
                      ? (_openBlock(), _createBlock(_component_el_tag, {
                          key: 3,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_el_tag, {
                          key: 4,
                          type: "danger"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_11
                          ]),
                          _: 1
                        }))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "",
            prop: "actions",
            align: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_el_button, null, {
                default: _withCtx(() => [
                  _hoisted_12
                ]),
                _: 1
              }),
              (row.downloadPath)
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    onClick: ($event: any) => (onDownload(row.downloadPath)),
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]), [
        [_directive_loading, loading.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_el_pagination, {
        layout: "prev, pager, next",
        "page-count": totalPages.value,
        size: "large",
        background: "",
        "current-page": _unref(filters).page,
        "onUpdate:current-page": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filters).page) = $event))
      }, null, 8, ["page-count", "current-page"])
    ])
  ], 64))
}
}

})